import ABrandLogo from './index.vue';

ABrandLogo.install = app => {
  app.component(ABrandLogo.name, ABrandLogo);
};

export default ABrandLogo;
